import { GenerateProviders } from '@/errorHandler';
import {
    DashboardBlockType,
    EntityDefinition,
    EntityPluginStep,
    SecurityRole,
    SensorDashBlockDef,
    SingleUser,
} from '@/types';
import { RoleParams } from '@/authorization';

export const User: EntityDefinition = {
    primaryKey: 'email',
    getPrimaryKey(row: any) {
        return row.firstname + ' ' + row.lastname;
    },
    name: 'User',
    pluralName: 'Users',
    endpointName: 'users',
    isPrimaryResolver: true,
    routes: {
        single: 'settingsUsersAddEdit',
        grid: 'settingsUsers',
    },
    lookupFields: {
        title: ['firstname', 'lastname'],
        detailLeft: 'relCustomer',
    },
    roleBasedFilters: {
        ROLE_USER: RoleParams.UserCustomer,
        ROLE_OWNER: RoleParams.UserCustomer,
    },
    providers: GenerateProviders(
        'users',
        {
            entity: 'User',
            params: {
                attributes: [
                    'email',
                    'firstname',
                    'lastname',
                    'phone',
                    'roles',
                    'relCustomer',
                    'password',
                    'locale',
                    'timezone',
                    'dashboard',
                    'adminCustomerIds',
                    'relUserGroup',
                    'msLoginEnabled',
                    'upn',
                ],
            },
        },
        undefined,
        [
            {
                message: 'LoadSingle',
                stage: 'Post',
                priority: 1,
                action: async (user) => {
                    if (
                        user.roles.filter((r) => r === SecurityRole.RoleViewer)
                            .length > 0
                    ) {
                        user.roles = [SecurityRole.RoleViewer];
                    }

                    return user;
                },
            } as EntityPluginStep<SingleUser>,
            {
                message: 'LoadSingle',
                stage: 'Post',
                priority: 1,
                action: async (u) => {
                    if (u.adminCustomerIds) {
                        u.adminCustomerIds = u.adminCustomerIds.map(
                            (c) => '/customers/' + c,
                        );
                    }

                    return u;
                },
            } as EntityPluginStep<SingleUser>,
            {
                message: 'LoadSingle',
                stage: 'Post',
                priority: 1,
                action: async (u) => {
                    if (u.adminCustomerIds) {
                        u.adminCustomerIds = u.adminCustomerIds.map(
                            (c) => '/customers/' + c,
                        );
                    }

                    return u;
                },
            } as EntityPluginStep<SingleUser>,
            {
                message: 'LoadSingle',
                stage: 'Post',
                priority: 1,
                action: async (u) => {
                    if (u.msLoginEnabled === undefined || u.msLoginEnabled === null) {
                        u.msLoginEnabled = false;
                    }
                    return u;
                },
            } as EntityPluginStep<SingleUser>,
            {
                /**
                2024-02-16
                API STARTED RETURNING ROLES AS OBJECT INSTEAD OF AN ARRAY,
                WHICH IS NOT AS SPECIFIED
            */
                message: 'LoadSingle',
                stage: 'Post',
                priority: -1,
                action: async (u) => {
                    if (u.roles && !Array.isArray(u.roles)) {
                        u.roles = Object.values(u.roles);
                    }

                    return u;
                },
            } as EntityPluginStep<SingleUser>,
            {
                message: 'Update',
                stage: 'Pre',
                priority: 2,
                action: async (u) => {
                    if (u.data.adminCustomerIds) {
                        u.data.adminCustomerIds = [
                            ...u.data.adminCustomerIds.map((c) =>
                                c.replace(/\/customers\//g, ''),
                            ),
                        ];
                    }

                    return u;
                },
            } as EntityPluginStep<{ data: SingleUser; id: string }>,
        ],
    ),
};
